import { normalize } from './format';

/** Item pesquisável da busca geral (Ctrl+K): título pesa mais que o resto do texto. */
export interface SearchDoc {
  id: string;
  kind: string;
  title: string;
  /** Texto secundário (descrição, corpo da nota, CNPJ, e-mail…). */
  text?: string;
}

const words = (s: string) => s.split(/[^\p{L}\p{N}]+/u).filter(Boolean);

/**
 * Pontua um item para a busca: todos os termos precisam aparecer (no título ou no texto), sem acento e
 * sem diferença de maiúsculas. Título que começa com a busca > palavra do título que começa com o termo >
 * termo no meio do título > termo só no texto. Devolve 0 quando não combina.
 */
export function searchScore(doc: SearchDoc, query: string): number {
  const q = normalize(query).trim();
  if (!q) return 0;
  const title = normalize(doc.title), text = normalize(doc.text ?? '');
  const titleWords = words(title);
  let score = title.startsWith(q) ? 100 : title.includes(q) ? 40 : 0;
  for (const term of q.split(/\s+/)) {
    if (titleWords.some(w => w.startsWith(term))) score += 20;
    else if (title.includes(term)) score += 10;
    else if (text.includes(term)) score += 2;
    else return 0;
  }
  return score;
}

/** Itens que combinam, do mais para o menos relevante, até `perKind` de cada tipo. */
export function searchAll<T extends SearchDoc>(docs: readonly T[], query: string, perKind = 6): T[] {
  const scored = docs.map(d => ({ d, s: searchScore(d, query) })).filter(x => x.s > 0)
    .sort((a, b) => b.s - a.s || a.d.title.length - b.d.title.length || a.d.title.localeCompare(b.d.title, 'pt-BR'));
  const count = new Map<string, number>();
  const out: T[] = [];
  for (const { d } of scored) {
    const n = count.get(d.kind) ?? 0;
    if (n >= perKind) continue;
    count.set(d.kind, n + 1);
    out.push(d);
  }
  return out;
}
